const initGeoRedirect = () => {
  const STORAGE_KEY = 'geo_redirect_dismissed';

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const { hostname } = window.location;
  const isUSSite = hostname === 'venroy.com';
  const isAUSite = hostname === 'venroy.com.au';

  if (!isUSSite && !isAUSite) return;

  const POLL_INTERVAL = 2000;
  const POLL_TIMEOUT = 10000;

  const banner = document.querySelector('[data-geo-redirect]');
  const textEl = document.querySelector('[data-geo-redirect-text]');
  const acceptBtn = document.querySelector('[data-geo-redirect-accept]');
  const dismissButtons = document.querySelectorAll('[data-geo-redirect-dismiss]');

  if (!banner || !textEl || !acceptBtn || !dismissButtons.length) return;

  const buildRedirectUrl = () => {
    return isUSSite
      ? window.location.href.replace(hostname, 'venroy.com.au')
      : window.location.href.replace('venroy.com.au', 'venroy.com');
  };

  const MESSAGES = {
    US: "It looks like you're in the United States.\nWould you like to visit our United States store?",
    EU: "It looks like you're in the European Union.\nWe ship internationally from our Australian store.\nWould you like to visit our Australian store?",
    UK: "It looks like you're in the United Kingdom.\nWe ship internationally from our Australian store.\nWould you like to visit our Australian store?",
    AU: "It looks like you're in Australia.\nWould you like to visit our Australian store?",
    GE: "It looks like you're in Georgia.\nWould you like to visit our United States store?",
  };

  const EU_COUNTRY_CODES = new Set([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  ]);

  const getRegionGroup = (region) => {
    const normalizedRegion = String(region || '').toUpperCase();

    if (normalizedRegion.startsWith('EU')) return 'EU';
    if (normalizedRegion.startsWith('UK') || normalizedRegion.startsWith('GB')) return 'UK';
    if (normalizedRegion.startsWith('US')) return 'US';
    if (normalizedRegion.startsWith('AU')) return 'AU';
    if (normalizedRegion.startsWith('GE')) return 'GE';

    return null;
  };

  const getMessageByRegion = (region) => {
    const normalizedRegion = String(region || '').toUpperCase();
    const countryCode = normalizedRegion.substring(0, 2);
    const regionGroup = getRegionGroup(normalizedRegion);
    const isEURegion = regionGroup === 'EU' || EU_COUNTRY_CODES.has(countryCode);

    if (isAUSite && regionGroup === 'US') return MESSAGES.US;
    if (isAUSite && regionGroup === 'GE') return MESSAGES.GE;
    if (isUSSite && regionGroup === 'GE') return MESSAGES.EU;
    if (isUSSite && isEURegion) return MESSAGES.EU;
    if (isUSSite && regionGroup === 'UK') return MESSAGES.UK;
    if (isUSSite && regionGroup === 'AU') return MESSAGES.AU;

    return null;
  };

  const showBanner = (message, url) => {
    textEl.textContent = message;
    acceptBtn.href = url;
    banner.hidden = false;
  };

  dismissButtons.forEach((dismissButton) => {
    dismissButton.addEventListener('click', () => {
      sessionStorage.setItem(STORAGE_KEY, '1');
      banner.hidden = true;
    });
  });

  const interval = setInterval(() => {
    const region = window.Shopify?.customerPrivacy?.getRegion?.();
    if (!region) return;

    clearInterval(interval);
    const message = getMessageByRegion(region);

    if (message) {
      showBanner(message, buildRedirectUrl());
    }
  }, POLL_INTERVAL);

  setTimeout(() => clearInterval(interval), POLL_TIMEOUT);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeoRedirect);
} else {
  initGeoRedirect();
}
